import $ from 'jquery';

export default {
  name: 'ImgModal',

  props: {
    p_srcModalImg: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      zoomInOut: 0,
      rotateDeg: 0,

      $imgModal: null,
    };
  },

  computed: {
    c_isZoomInDisabled() {
      return 1 === this.zoomInOut;
    },

    c_isZoomOutDisabled() {
      return 0 === this.zoomInOut;
    },
  },

  methods: {
    zoomIn() {
      this.zoomInOut += 1;
    },

    zoomOut() {
      this.zoomInOut -= 1;
    },

    rotateLeft() {
      this.zoomInOut = 0;
      this.rotateDeg -= 90;
      if (this.rotateDeg < 0) {
        this.rotateDeg += 360;
      }
    },

    rotateRight() {
      this.zoomInOut = 0;
      this.rotateDeg += 90;
      if (this.rotateDeg >= 360) {
        this.rotateDeg -= 360;
      }
    },

    show() {
      this.$imgModal.modal('show');
    },
  },

  mounted() {
    this.$imgModal = $(this.$refs.imgModal);
    this.$imgModal.on('hidden.bs.modal', () => {
      this.zoomInOut = 0;
      this.rotateDeg = 0;
    });
  },
};
